//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import { sendCtmEvtLog } from '@/utils/log'
import BuildingDetailConsultPrice from './_building_detail_consult_price'

export default {
    props: {
        current_house: {
            type: Object
        },
        house: {
            type: Object
        },
        show_house_count: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CommonImg,
        BuildingDetailConsultPrice
    },
    methods: {
        openMap () {
            sendCtmEvtLog('开盘地址点击')
            this.$emit('openMap')
        },
        checkCustomPriceShow (current_house) {
            return current_house && current_house.customized_price && current_house.customized_price.length
        },
        checkPriceShow (current_house) {
            return current_house
                    &&
                    (
                        this.checkCustomPriceShow(current_house)
                        ||
                        (current_house.price_desc_arr && current_house.price_desc_arr.length)
                    )
        },
        getAddress (house) {
            if (!house) {
                return ''
            }
            return [house.zone, house.address].reduce(function (prev, value) {
                if (value) {
                    prev.push(value)
                }
                return prev
            }, []).join('-')
        },
    }
}
